module.exports = __webpack_public_path__ + "static/media/expand_collapse.5044f435.svg";